import { render, staticRenderFns } from "./proIntroduction.vue?vue&type=template&id=4be6bbf7&scoped=true"
import script from "./proIntroduction.vue?vue&type=script&lang=js"
export * from "./proIntroduction.vue?vue&type=script&lang=js"
import style0 from "./proIntroduction.vue?vue&type=style&index=0&id=4be6bbf7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be6bbf7",
  null
  
)

export default component.exports